import axios from "axios";
import { notification } from "antd";
import moment from "moment";

import {
  DELETE_USER,
  GET_USERS,
  GET_USER_BY_ID,
  SET_USER_TO_NULL,
} from "./types";
import { NavigationPath } from "../../../helpers/constants";
import { AuthorizedApiService } from "../../../services/apiServices";

export const getUsers = () => async (dispatch) => {
  try {
    AuthorizedApiService.get("user/supplier")
      .then((res) => {
        const { status, data } = res;
        if (status !== 200) {
          notification.error({
            message: "Something went wrong,can not get users!",
          });
          return;
        }
        const users = data.map((dataUser) => ({
          key: dataUser.id,
          ime: dataUser.userName,
          dobavljac: dataUser.supplierId,
          email: dataUser.email,
          rola: dataUser.role,
          datum: moment(dataUser.createdAt).format("YYYY-MM-DD HH:mm:ss"),
        }));
        dispatch({
          type: GET_USERS,
          payload: users,
        });
      })
      .catch((err) => {
        notification.error({
          message: "Something went wrong,can not get users!",
        });
      });
  } catch (error) {
    console.log(error);
  }
};

export const deleteUser = (ids) => async (dispatch) => {
  try {
    AuthorizedApiService.delete("user", {
      data: { ids },
    })
      .then((res) => {
        const { status, data } = res;
        if (status !== 200) {
          notification.error({
            message: "Something went wrong!",
          });
          return;
        }
        notification.success({
          message: ids.length === 1 ? "User deleted!" : "Users deleted!",
        });
        dispatch(getUsers());
      })
      .catch((err) => {
        notification.error({
          message: "Something went wrong!",
        });
      });
  } catch (error) {
    console.log(error);
  }
};

export const getUserById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: SET_USER_TO_NULL,
    });
    AuthorizedApiService.get(`user/${id}`)
      .then((res) => {
        const { status, data } = res;
        if (status !== 200) {
          notification.error({
            message: "Something went wrong!",
          });
          return;
        }
        dispatch({
          type: GET_USER_BY_ID,
          payload: data,
        });
      })
      .catch((err) => {
        notification.error({
          message: "Something went wrong!",
        });
      });
  } catch (error) {
    console.log(error);
  }
};

export const updateUserById = (userToUpdate, id) => async (dispatch) => {
  try {
    AuthorizedApiService.put(`user/${id}`, userToUpdate)
      .then((res) => {
        const { status, data } = res;
        if (status !== 200) {
          notification.error({
            message: "Update user error!",
          });
          return;
        }
        notification.success({
          message: "Update user success!",
        });
        window.location = NavigationPath.USERS_ROUTE;
      })
      .catch((err) => {
        notification.error({
          message: "Update user error!",
        });
      });
  } catch (error) {
    console.log(error);
  }
};
